export default __webpack_public_path__ + "static/media/logoDEWA.78264dd2.svg";